import { FC, useState } from "react";
import { Box } from "@mui/material";
import { IPost } from "@/store/api/postApiData";
import PostFooter from "@/pages/Home/components/PostFooter";
import PostActions from "@/pages/Home/components/PostActions";

interface IPreviewLongPostFooterProps {
  lastThreeLike?: string[];
  isPaidContent?: boolean;
  chips?: string[];
  slider?: number;
  price?: string;
  post?: IPost;
  totalLikesAmount: number;
}

const PreviewLongPostFooter: FC<IPreviewLongPostFooterProps> = ({
  lastThreeLike = [],
  isPaidContent = false,
  chips = [],
  slider = 0,
  price = "0",
  post,
  totalLikesAmount,
}) => {
  const fallbackPost: IPost = {
    uid: "fallback",
    content: "",
    published: false,
    postType: isPaidContent ? "PAID" : "FREE",
    price: isPaidContent ? Number(price) : null,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isLongForm: false,
    freeContentRange: null,
    topic: "STOCKS",
    cashtags: [],
    hashtags: chips,
    attachments: [],
    sources: [],
    subtypes: chips,
    author: {
      uid: "fallback",
      username: "Unknown",
      name: "Unknown",
      surname: "",
      image: { url: lastThreeLike[0] || "" },
    },
    comments: [],
    likesCount: lastThreeLike.length,
    zapsCount: 0,
    commentsCount: 0,
    savesCount: 0,
    isLiked: post?.isLiked || false,
    isSaved: false,
    isZapped: post?.isZapped || false,
    sentiment: slider + 5,
    likersPreview: lastThreeLike,
    zappersPreview: [],
    isPurchased: isPaidContent,
    totalZapsAmount: post?.totalZapsAmount || 0,
    isArbitraryPrice: false,
    reactionsPreview: lastThreeLike,
    totalLikesAmount: totalLikesAmount,
  };

  const postToRender = post ?? fallbackPost;
  const [zapsCountState, setZapsCountState] = useState(postToRender.zapsCount);
  const [isLikedTemporary, setIsLikedTemporary] = useState(false);
  const [totalZapsAmountState, setTotalZapsAmountState] = useState(postToRender.totalZapsAmount);
  return (
    <Box sx={{ width: "756px" }}>
      <PostFooter
        totalLikesAmount={totalLikesAmount}
        post={postToRender}
        lastThreeLike={lastThreeLike}
        zapsCountState={zapsCountState}
        isLikedTemporary={isLikedTemporary}
        totalZapsAmountState={totalZapsAmountState}
      />
      <PostActions
        post={postToRender}
        zapsCountState={zapsCountState}
        setZapsCountState={setZapsCountState}
        isLikedTemporary={isLikedTemporary}
        setIsLikedTemporary={setIsLikedTemporary}
        totalZapsAmountState={totalZapsAmountState}
        setTotalZapsAmountState={setTotalZapsAmountState}
      />
    </Box>
  );
};

export default PreviewLongPostFooter;
